import { useContext, useMemo } from "react";
import { ThemeContext } from "../context/ThemeContextProvider";
import { getWiserTheme } from "../shared/theme/wiserTheme";

export const useWiserTheme = () => {
  const { darkModeActive, switchColorMode } = useContext(ThemeContext);
  const tokens = useMemo(() => getWiserTheme(darkModeActive), [darkModeActive]);

  return {
    darkModeActive,
    switchColorMode,
    tokens,
  };
};
